var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44152 4.375H7.97217V2.96875C7.97217 1.33203 6.63846 0 4.99967 0C3.36088 0 2.02717 1.33203 2.02717 2.96875V4.375H1.55783C1.03959 4.375 0.619141 4.79492 0.619141 5.3125V9.0625C0.619141 9.58008 1.03959 10 1.55783 10H8.44152C8.95975 10 9.3802 9.58008 9.3802 9.0625V5.3125C9.3802 4.79492 8.95975 4.375 8.44152 4.375ZM6.4077 4.375H3.59164V2.96875C3.59164 2.19336 4.2233 1.5625 4.99967 1.5625C5.77604 1.5625 6.4077 2.19336 6.4077 2.96875V4.375Z",
    fill: "#99ADBA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSmall);
export default __webpack_public_path__ + "static/media/lock-small.65cad66b.svg";
export { ForwardRef as ReactComponent };